import { FormatHelper } from '@adp-wfn/mdf-core';
import WebViewer from '@pdftron/pdfjs-express-viewer';
import React, { useEffect, useRef } from 'react';
import packageJson from '../../package.json';

const version = packageJson.version;

type PdfViewerProps = {
  documentName?: string;
  file: any;
  hideDownloadIcon?: boolean;
  hidePrintIcon?: boolean;
  pageWidth?: string;
  searchKeywords?: any;
};

export const PdfViewer = ({
  documentName,
  file,
  hideDownloadIcon,
  hidePrintIcon,
  pageWidth,
  searchKeywords
}: PdfViewerProps) => {
  const viewer = useRef<HTMLDivElement>(null);
  const licenseKey = '0zZ1j9IDTS0yyeBosKdd';
  const ariaLabelText = FormatHelper.formatMessage('@@PDFVIEWER_ARIA_LABEL_TEXT');
  const mdfConfigUrl = 'https://static.workforcenow.adp.com/mas/mdf-components/' + version + '/pdfjsexpress';
  const sendPostMessage = () => {
    const iframeWindow = viewer.current?.querySelector('iframe')?.contentWindow;

    if (iframeWindow) {
      iframeWindow.postMessage(
        {
          type: 'OPEN_DOCUMENT_URL',
          file,
          searchKeywords,
          documentName,
          hideDownloadIcon,
          hidePrintIcon,
          pageWidth
        },
        '*'
      );
    }
  };
  useEffect(() => {
    WebViewer(
      {
        path: mdfConfigUrl,
        config: mdfConfigUrl + '/pdfjs.config.js',
        licenseKey: licenseKey
      },
      viewer.current
    ).then(() => {
      sendPostMessage();
    });
  }, [file, searchKeywords, documentName, hideDownloadIcon, hidePrintIcon, pageWidth]);

  return (
    <div className="App">
      <div
        className="webviewer h-screen"
        aria-label={ariaLabelText}
        id="pdf-viewer-component"
        ref={viewer}
      ></div>
    </div>
  );
};

export default PdfViewer;
